@let localVideos = vrVideos();
@let local360 = vr360();

@if (variant() === 'geomarker') {
  <section class="geomarker-vr-card">
    <div class="geomarker-vr-card__content">
      <span class="geomarker-vr-card__eyebrow">
        <i class="inm-icon-vr-glasses" aria-hidden="true"></i>
        {{ 'geomarker.immersive_eyebrow' | translate }}
      </span>
      <h2>{{ 'geomarker.immersive_title' | translate }}</h2>
      <p>{{ 'geomarker.immersive_description' | translate }}</p>
      <button type="button" (click)="openSelectedMedia()">
        <i class="fa-solid fa-play" aria-hidden="true"></i>
        {{ 'geomarker.immersive_cta' | translate }}
      </button>
    </div>
    <div class="geomarker-vr-card__media">
      <app-carousel-vr
        variant="featured"
        [vrMedia]="vrMedia()"
        (activeIndexChange)="onMediaIndexChange($event)"
      />
    </div>
  </section>
} @else {
  <div class="col-12">
    <div class="d-flex flex-wrap justify-content-center align-items-center gap-1 mb-2">
      <img class="me-1" src="img/icons/ra_icon_circle.png" height="28" alt="" />
      <h3 class="dark-blue-text text-shadow-white fs-3 text-center">
        {{ 'contenido_realidad_virtual' | translate | capitalize }}
      </h3>
    </div>
    <p class="text-center">{{ 'geomarker.descripcion_vr' | translate }}</p>
  </div>
  @if (localVideos?.length || local360?.length) {
    <div class="col-12"><app-carousel-vr [vrMedia]="vrMedia()" /></div>
  }
}
